// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui-maps-leaflet {\n  height: 600px;\n}\n.ui-maps-leaflet .infowindow {\n  width: 240px;\n}\n.ui-maps-leaflet .infowindow .infowindow__img img {\n  width: 100%;\n}\n.ui-maps-leaflet::after {\n  content: none !important;\n}\n.ui-maps-leaflet .info-window {\n  display: none;\n}\n.ui-maps-leaflet .all {\n  padding-bottom: 1rem;\n}\n.ui-maps-leaflet .code {\n  color: #1791fa;\n  font-size: 15px;\n  padding-bottom: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
